import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import BlogLayout from './BlogLayout';
import { POSTS } from '../blog/posts';

const PAGE_TITLE = 'Blog | Plum';
const PAGE_DESCRIPTION =
  'Articles on how Plum uses AI to plan renovations, generate designs, and help homeowners get comparable contractor quotes.';

// Set the document title and meta description for the blog index. Because the
// app is a client-rendered SPA, this is how each public page gets a unique
// title/description for browsers and (JS-executing) crawlers.
function useDocumentMeta(title, description) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    const previousDescription = meta ? meta.getAttribute('content') : null;
    if (meta && description) meta.setAttribute('content', description);
    return () => {
      document.title = previousTitle;
      if (meta && previousDescription !== null) {
        meta.setAttribute('content', previousDescription);
      }
    };
  }, [title, description]);
}

function formatDate(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

function BlogPage() {
  useDocumentMeta(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <BlogLayout>
      <Container style={{ maxWidth: '800px' }} className="py-4">
        <h1>The Plum Blog</h1>
        <p className="text-muted">
          How Plum uses AI to help homeowners design renovations, plan the work,
          and hire the right contractor.
        </p>

        <div className="blog-post-list mt-4">
          {POSTS.map((post) => (
            <article key={post.slug} className="blog-post-card mb-4 pb-4 border-bottom">
              <h2 className="h4 mb-2">
                <a href={`/blog/${post.slug}`} className="blog-post-link">
                  {post.title}
                </a>
              </h2>
              <p className="text-muted small mb-2">
                {formatDate(post.date)} · {post.readMinutes} min read
              </p>
              <p className="mb-2">{post.description}</p>
              <a href={`/blog/${post.slug}`}>Read more →</a>
            </article>
          ))}
        </div>
      </Container>
    </BlogLayout>
  );
}

export { useDocumentMeta };
export default BlogPage;
